$(document).ready(function() {
  // 職種の初期値をセット
  changeSelectOccupations();

  // 教科の初期値をセット
  changeSelectSubjects();

  // 勤務地の初期値をセット
  changeSelectPrefectures();

  // パラメータがあった時検索フォームを展開する
  const paramsToCheck = [
    'search_offer_form[employment_ids][]',
    'search_offer_form[arrival_date_year_from]',
    'search_offer_form[arrival_date_month_from]',
    'search_offer_form[arrival_date_year_to]',
    'search_offer_form[arrival_date_month_to]',
    'search_offer_form[feature_ids][]',
    'search_offer_form[keyword]'
  ];

  const hasValue = paramsToCheck.some(param => getQueryParam(param) !== null && getQueryParam(param) !== '');

  if (hasValue) {
    const targetElementsToHide = document.querySelectorAll('.more-show-btn.js-target-open, .more-show-btn.-reset-top');
    targetElementsToHide.forEach(element => {
      element.style.display = 'none';
    });

    const fieldsets = document.querySelectorAll('fieldset.c-field');
    fieldsets.forEach(fieldset => {
      const currentValue = fieldset.getAttribute('data-show');
      // data-show 属性が存在し、かつ 'false' の場合に 'true' に変更
      if (currentValue !== null && currentValue === 'false') {
        fieldset.setAttribute('data-show', 'true');
      }
    });

    const elementsToShow = document.querySelectorAll('.js-target-close.more-show-btn, .more-show-btn.-reset');
    elementsToShow.forEach(element => {
      element.style.display = 'block';
    });
  }
});

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

//職種を選択
$(document).on('change', '.select-occupations', function() {
  changeSelectOccupations();
});

function changeSelectOccupations(){
  const selectedOccupations = [];
  $('input[name="search_offer_form[occupation_ids][]"]:checked').each(function() {
    selectedOccupations.push($(this).siblings('.c-checkbox__text').text());
  });

  const outputText = selectedOccupations.length > 0 ? selectedOccupations.join(', ') : '未選択';
  $('#selected-occupations').text(outputText);
}

// "すべてを選択" のチェックボックスが変更されたときの処理
$(document).on('change', '#checkAllOccupation', function() {
  if ($(this).is(':checked')) {
    $('.occupation-checkbox').prop('checked', true); // すべての都道府県のチェックボックスをチェック
  } else {
    $('.occupation-checkbox').prop('checked', false); // すべての都道府県のチェックを外す
  }
  changeSelectOccupations();
});

$(document).on('change', '.occupation-checkbox', function() {
  // 全ての都道府県のチェックが外れた場合に "すべてを選択 のチェックを外す
  if ($('.occupation-checkbox:checked').length === $('.occupation-checkbox').length) {
    $('#checkAllOccupation').prop('checked', true);
  } else {
    $('#checkAllOccupation').prop('checked', false);
  }
});


//教科を選択
$(document).on('change', '.select-subjects', function() {
  changeSelectSubjects();
});

function changeSelectSubjects(){
  const selectedSubjects = [];
  $('input[name="search_offer_form[subject_ids][]"]:checked').each(function() {
    selectedSubjects.push($(this).siblings('.c-checkbox__text').text());
  });

  const outputText = selectedSubjects.length > 0 ? selectedSubjects.join(', ') : '未選択';
  $('#selected-subjects').text(outputText);
}

//勤務地を選択
$(document).on('change', '.select-prefectures', function() {
  changeSelectPrefectures();
});

function changeSelectPrefectures(){
  const selectedPrefectures = [];
  $('input[name="search_offer_form[prefecture_ids][]"]:checked').each(function() {
    selectedPrefectures.push($(this).siblings('.c-checkbox__text').text());
  });

  const outputText = selectedPrefectures.length > 0 ? selectedPrefectures.join(', ') : '未選択';
  $('#selected-prefectures').text(outputText);
}

// "すべてを選択" のチェックボックスが変更されたときの処理
$(document).on('change', '#checkAllPrefecture', function() {
  if ($(this).is(':checked')) {
    $('.prefecture-checkbox').prop('checked', true); // すべての都道府県のチェックボックスをチェック
  } else {
    $('.prefecture-checkbox').prop('checked', false); // すべての都道府県のチェックを外す
  }
  changeSelectPrefectures();
});

$(document).on('change', '.prefecture-checkbox', function() {
  // 全ての都道府県のチェックが外れた場合に "すべてを選択 のチェックを外す
  if ($('.prefecture-checkbox:checked').length === $('.prefecture-checkbox').length) {
    $('#checkAllPrefecture').prop('checked', true);
  } else {
    $('#checkAllPrefecture').prop('checked', false);
  }
});
